<template>
  <div class="p-15" :class="{ 'is-compact-orders': compact }">
    <!-- 申请退款/取消订单 弹出框 -->
    <UiDialog
      v-if="canRefundOrder(refundItem)"
      :title="$t(refundType === 'buyer' ? '确认退款' : '取消订单')"
      v-model="dialogVisible"
      :append-to-body="appendToBody"
      width="36%"
    >
      <div v-if="refundType === 'buyer'" class="refund-current-status">{{ $t("当前退款状态：已申请") }}</div>
      <el-form ref="refundFormRef" :model="refundForm" :rules="refundRules" label-position="left" label-width="88px">
        <el-form-item :label="$t(refundType === 'buyer' ? '确认退款金额' : '退款金额')" prop="refundPrice" required>
          <UiInput v-model="refundForm.refundPrice" inputmode="decimal" :placeholder="$t('输入金额，不可超过订单总金额')">
            <template slot="append">{{ $t("元") }}</template>
          </UiInput>
          <div class="fc-w">{{ $t(refundType === 'buyer' ? `买家申请退款金额${refundApply_price}元，此订单总额为${refundTotal_price}元` :
              `此订单总额为${refundTotal_price}元`) }}</div>
          <div v-if="refundType === 'buyer'" class="fc-w">{{ $t("请核对金额，可直接修改；确认后将按此金额退款") }}</div>
        </el-form-item>

        <el-form-item v-if="needShipmentConfirmBeforeRefund" :label="$t('货物状态')" required>
          <UiSegmentedControl
            v-model="refundShipmentResult"
            :options="shipmentResultOptions"
          />
          <div class="fc-w">{{ $t("先确认货物状态，系统会处理配送状态后再退款") }}</div>
        </el-form-item>

        <el-form-item v-if="refundType !== 'buyer'" :label="$t('退款原因')" prop="cancelReasonSelect" required>
          <UiSelect
            v-model="refundForm.cancelReasonSelect"
            filterable
            clearable
            :popper-append-to-body="appendToBody"
            :placeholder="$t('请选择退款原因')"
          >
            <el-option v-for="(item, index) in cancelReasonOptions" :key="index" :label="$t(item)" :value="item" />
          </UiSelect>
        </el-form-item>

        <el-form-item
          v-if="refundType !== 'buyer' && showCancelReasonInput"
          :label="$t('其他原因')"
          prop="cancelReasonInput"
          required
        >
          <UiInput
            v-model="refundForm.cancelReasonInput"
            type="textarea"
            :rows="3"
            maxlength="120"
            show-word-limit
            :placeholder="$t('请输入其他原因')"
          />
        </el-form-item>
      </el-form>

      <span slot="footer" class="dialog-footer">
        <UiButton size="medium" type="danger" action="save" :loading="refundSubmittingId !== null" :disabled="refundSubmittingId !== null" @click="refund">{{ $t(refundType === 'buyer' ? '确认退款' : '确认取消订单') }}</UiButton>
        <UiButton action="close" size="medium" @click="dialogVisible = false">{{ $t("关闭") }}</UiButton>
      </span>
    </UiDialog>

    <!-- 任务tab -->
    <UiCollapse v-model="activeNames" accordion>
      <UiMotionList>
        <UiCollapseItem
          class="mainFontColor w-100 flex column mc ofa"
          v-for="(item, index) in displayList"
          :key="item.id"
          :name="item.id"
        >
          <template slot="title">
            <div class="w-100 order-summary" :class="activeNames === item.id ? 'fc-b fb' : ''">
              <div class="l w-50 order-summary__heading"><span class="order-summary__id">#{{ item.food_sn || '--' }}</span><span v-if="item.receive_site_name" class="order-summary__site" :title="item.receive_site_name"><span class="order-summary__separator"> · </span>{{ item.receive_site_name }}</span>
                <span v-if="type == '退款处理' && item.refund_status === '已同意'" class="refund-fail-note">{{ $t("（同意买家退款处理中）") }}</span>
                <span v-else-if="type == '退款处理' && item.refund_status === '主动退'" class="refund-fail-note">{{ $t("（取消订单退款处理中）") }}</span>
                <span v-else-if="type == '退款处理' && item.refund_status === '程序退'" class="refund-fail-note">{{ $t("（系统退款处理中）") }}</span>
              </div>
              <div v-if="type == '未接单'" class="r w-50 fr p-r-15">{{ $t("付款时间：{0}", [(parseTime(item.paid_time, '{m}-{d} {h}:{i}'))]) }}</div>
              <div v-else-if="type == '已接单'" class="r w-50 fr p-r-15">{{ $t("接单时间：{0}", [(parseTime(item.received_time, '{m}-{d} {h}:{i}'))]) }}</div>
              <div v-else-if="type == '已发货'" class="r w-50 fr p-r-15">{{ $t("发货时间：{0}", [(parseTime(item.shipped_time, '{m}-{d} {h}:{i}'))]) }}</div>
              <div v-else-if="type == '退款处理'" class="r w-50 fr p-r-15">{{ $t("申请时间：{0}", [(parseTime(item.refundapply_time, '{m}-{d} {h}:{i}'))]) }}</div>
            </div>
          </template>

          <component
            :is="compact ? 'UiDialog' : 'div'"
            :class="{ 'is-compact-orders': compact, 'order-detail-card': !compact }"
            v-bind="compact ? { value: activeNames === item.id, title: `${$t(type)} #${item.food_sn || '--'}`, appendToBody: true, width: '880px', customClass: 'workbench-order-detail-dialog' } : {}"
            @input="handleDetailVisibility(item.id, $event)"
          >
          <div :class="{ 'order-detail-card': compact }">
          <el-descriptions class="order-primary-info" :direction="compact ? 'horizontal' : 'vertical'" :column="3" border>
            <el-descriptions-item :label="$t('状态')">{{ $t(item.shipment_status) }}</el-descriptions-item>
            <el-descriptions-item :label="$t('订单号')"><span class="order-number" :title="$t(item.order_sn)">{{ item.order_sn }}</span></el-descriptions-item>
            <el-descriptions-item :label="$t('取餐号')">{{ item.food_sn }}</el-descriptions-item>
          </el-descriptions>

          <section class="order-detail-section">
            <UiFormDivider :title="$t('配送信息')" />
            <el-descriptions class="order-delivery-info" :direction="compact ? 'horizontal' : 'vertical'" :column="3" border>
            <el-descriptions-item :label="$t('收货人')">{{ item.receiver }}</el-descriptions-item>
            <el-descriptions-item :label="$t('手机号')">{{ item.tel }}</el-descriptions-item>
            <el-descriptions-item :label="$t('收货站点')">{{ item.receive_site_name }}</el-descriptions-item>
            </el-descriptions>
          </section>

          <div class="order-metrics">
            <div><span>{{ $t("总重量") }}</span><strong>{{ item.total_weight }}<small>{{ $t("克") }}</small></strong></div>
            <div><span>{{ $t("订单总价") }}</span><strong>{{ item.total_price }}<small>{{ $t("元") }}</small></strong></div>
            <div><span>{{ $t("货品数量") }}</span><strong>{{ item.total_num }}<small>{{ $t("件") }}</small></strong></div>
          </div>

          <section v-if="item.refund_status != '未申请' || customerRemarkText(item)" class="order-detail-section order-note">
            <UiFormDivider :title="$t(item.refund_status == '未申请' ? '客户备注' : '退款说明')" />
            <p>{{ item.refund_status == '未申请' ? customerRemarkText(item) : formatRefundRemark(item.refund_remark) }}</p>
          </section>

          <section class="order-detail-section order-products">
            <UiFormDivider :title="$t('商品明细')" />
            <div class="order-products-scroll" :tabindex="compact ? 0 : null" :role="compact ? 'region' : null" :aria-label="$t(compact ? '商品明细，可滚动' : null)">
              <UiTable :min-width="0" :data="orderProductRows(item)" :span-method="orderProductSpan">
                <UiTableColumn prop="productGroupName" :label="$t('商品名称')" :width="compact ? 96 : 120" class-name="order-product-group-cell">
                  <template slot-scope="scope">
                    <div class="order-product-group">{{ scope.row.productGroupName }}</div>
                  </template>
                </UiTableColumn>
                <UiTableColumn prop="sku_name" :label="$t('单品名称')" min-width="160" class-name="order-product-name-cell">
                  <template slot-scope="scope">
                    <div class="order-product-name">{{ scope.row.sku_name }}</div>
                    <div v-if="skuPurchaseChannelText(scope.row, item.shop_id)" class="order-product-channel">{{ skuPurchaseChannelText(scope.row, item.shop_id) }}</div>
                  </template>
                </UiTableColumn>
                <UiTableColumn :label="$t('商品编号')" :min-width="compact ? 80 : 140" show-overflow-tooltip>
                  <template slot-scope="scope">
                    {{ scope.row.sku_number }}
                  </template>
                </UiTableColumn>
                <UiTableColumn :label="$t('数量')" :width="compact ? 64 : 80" align="right" class-name="order-product-quantity" show-overflow-tooltip>
                  <template slot-scope="scope">
                    {{ scope.row.sku_totol }}{{ $t(scope.row.sku_unit) }}
                  </template>
                </UiTableColumn>
                <UiTableColumn v-if="compact" :label="$t('库存数量')" width="88" align="right" show-overflow-tooltip>
                  <template slot-scope="scope">{{ $t(skuStockText(scope.row, item.shop_id)) }}</template>
                </UiTableColumn>
              </UiTable>
            </div>
          </section>

          </div>
          <section :slot="compact ? 'footer' : null" class="order-detail-section order-actions">
            <UiFormDivider v-if="!compact" :title="$t('订单操作')" />
              <UiButtonGroup v-if="type == '退款处理'">
                <template v-if="['已同意', '主动退', '程序退'].includes(item.refund_status)">
                  <UiButton v-permission="'terminal.dashboard'" type="danger" loading disabled icon="iconfont icon-cuowu">
                    <font class="m-l-5">{{ $t("退款中...") }}</font>
                  </UiButton>
                </template>

                <template v-else-if="item.refund_status === '已申请'">
                  <UiButton
                    v-if="canRefundOrder(item)"
                    @click="setRefundItem(item, 'buyer')"
                    :loading="isRefundBusy(item)"
                    :disabled="isRefundBusy(item)"
                    type="danger"
                    icon="el-icon-edit"
                  >
                    <font v-if="isRefundBusy(item)" class="m-l-5">{{ $t("退款中...") }}</font>
                    <template v-else>
                      <font class="m-l-5">{{ $t("申请金额") }} ¥{{ fenToYuan(yuanToFen(item.apply_price)) }}</font>
                      <i class="iconfont icon-zhengque refund-edit-icon" aria-hidden="true" />
                      <font class="m-l-5">{{ $t("同意退款") }}</font>
                    </template>
                  </UiButton>

                  <UiButton
                    v-permission="'terminal.dashboard'"
                    @click="confirmRejectRefund(item)"
                    :disabled="isRefundBusy(item) || (dialogVisible && refundItem && refundItem.id === item.id)"
                    type="warning"
                    icon="iconfont icon-cuowu"
                  >
                    <font class="m-l-5">{{ $t("拒绝退款") }}</font>
                  </UiButton>
                </template>
              </UiButtonGroup>

              <UiButtonGroup v-else-if="type == '未接单'">
                <UiButton
                  v-if="canRefundOrder(item)"
                  @click="setRefundItem(item, 'seller')"
                  :loading="isRefundBusy(item)"
                  :disabled="isRefundBusy(item)"
                  type="danger"
                  icon="iconfont icon-cuowu"
                >
                  <font class="m-l-5">{{ $t(isRefundBusy(item) ? '退款中...' : '取消订单') }}</font>
                </UiButton>
                <UiButton v-if="!isWebClient" v-permission="'terminal.dashboard'" :loading="isOrderPrinting(item)" :disabled="isOrderPrinting(item) || isRefundBusy(item) || (dialogVisible && refundItem && refundItem.id === item.id)" @click="orderPrint(index)" type="info" icon="iconfont icon-dayin">
                  <font class="m-l-5">{{ $t("打印小票") }}<span v-if="printCount(item)" class="print-count">{{ $t("已打印{0}次", [(printCount(item))]) }}</span></font>
                </UiButton>
                <UiButton
                  v-permission="'terminal.dashboard'"
                  @click="questAss(item.id, 'shipment_status', '已接单')"
                  :disabled="isRefundBusy(item)"
                  type="primary"
                  icon="iconfont icon-chengjie"
                >
                  <font class="m-l-5">{{ $t("确认接单") }}</font>
                </UiButton>
              </UiButtonGroup>

              <UiButtonGroup v-else-if="type == '已接单'">
                <UiButton
                  v-if="canRefundOrder(item)"
                  @click="setRefundItem(item, 'seller')"
                  :loading="isRefundBusy(item)"
                  :disabled="isRefundBusy(item)"
                  type="danger"
                  icon="iconfont icon-cuowu"
                >
                  <font class="m-l-5">{{ $t(isRefundBusy(item) ? '退款中...' : '取消订单') }}</font>
                </UiButton>
                <UiButton v-if="!isWebClient" v-permission="'terminal.dashboard'" :loading="isOrderPrinting(item)" :disabled="isOrderPrinting(item) || isRefundBusy(item) || (dialogVisible && refundItem && refundItem.id === item.id)" @click="orderPrint(index)" type="info" icon="iconfont icon-dayin">
                  <font class="m-l-5">{{ $t("打印小票") }}<span v-if="printCount(item)" class="print-count">{{ $t("已打印{0}次", [(printCount(item))]) }}</span></font>
                </UiButton>
              </UiButtonGroup>

              <UiButtonGroup v-else-if="type == '已发货'">
                <template v-for="plane in planes">
                  <UiButton
                    v-if="plane.id === item.by_plane_id"
                    :key="plane.id"
                    v-permission="'terminal.dashboard'"
                    @click="handlerRouterPlane(plane)"
                    :disabled="isRefundBusy(item)"
                    type="primary"
                    icon="iconfont icon-wurenji"
                  >
                    <font class="m-l-5">{{ plane.name }}</font>
                  </UiButton>
                </template>
              </UiButtonGroup>
          </section>
          </component>
        </UiCollapseItem>
      </UiMotionList>

      <div v-if="displayList.length === 0" class="p-t-60 p-b-60 seatFontColor fc">
        <i class="iconfont icon-meiyoushuju f-s-100"></i>
        <div>{{ $t("空空如也") }}</div>
      </div>
    </UiCollapse>
  </div>
</template>

<script>
import { t } from '@/i18n'
import { parseTime } from '@/utils/index'
import { questAss, refund, finishDeliveryTask, recordOrderPrint } from '@/utils/api/table'
import { isReceiptPrinterConnected } from '@/utils/clientTools'
import { hasPermission } from '@/utils/authorization'
import { scheduleRefundReconciliation } from '@/utils/refundReconciliation'

export default {
  name: 'QuestTabs',
  data () {
    const checkRefundPrice = (rule, value, callback) => {
      const v = String(value || '').trim()
      if (!v) return callback(new Error('请填写退款金额'))
      if (!/^\d+(\.\d{1,2})?$/.test(v)) return callback(new Error('退款金额格式不正确'))

      const refundFen = this.yuanToFen(v)
      const totalFen = this.yuanToFen(this.refundTotal_price || 0)

      if (refundFen <= 0) return callback(new Error('退款金额必须大于0'))
      if (refundFen > totalFen) return callback(new Error('退款金额不可超过订单总金额'))

      callback()
    }

    const checkCancelReason = (rule, value, callback) => {
      if (this.refundType === 'buyer') return callback()
      if (!String(value || '').trim()) return callback(new Error('请选择退款原因'))
      callback()
    }

    const checkOtherReason = (rule, value, callback) => {
      if (this.refundType === 'buyer') return callback()
      if (this.showCancelReasonInput && !String(value || '').trim()) return callback(new Error('请输入其他原因'))
      callback()
    }

    return {
      activeNames: [],
      dialogVisible: false,
      refundIndex: null,
      refundSubmittingId: null,
      refundTotal_price: null,
      refundApply_price: null,
      refundOrder_sn: null,
      refundShop_id: null,
      refundType: null,
      refundItem: null,
      refundShipmentResult: '',
      printingOrderIds: [],
      shipmentResultOptions: [
        { value: 'undelivered', label: '未送达' },
        { value: 'delivered', label: '已送达' }
      ],

      refundForm: {
        refundPrice: '',
        cancelReasonSelect: '',
        cancelReasonInput: ''
      },

      refundRules: {
        refundPrice: [{ validator: checkRefundPrice, trigger: 'blur' }],
        cancelReasonSelect: [{ validator: checkCancelReason, trigger: 'change' }],
        cancelReasonInput: [{ validator: checkOtherReason, trigger: 'blur' }]
      }
    }
  },

  props: {
    compact: { type: Boolean, default: false },
    list: {
      type: Array,
      required: true
    },
    type: {
      type: String,
      required: true,
      default: ''
    },
    shopId: {
      type: [String, Number],
      default: ''
    },
    appendToBody: {
      type: Boolean,
      default: true
    }
  },

  computed: {
    purchaseChannelBySku () {
      const channels = new Map()
      if (!hasPermission(this.$store.state.user, 'product.sku.view')) return channels
      ;(this.$store.state.skuList || []).forEach(sku => {
        if (sku.purchase_channel != null) channels.set(`${sku.shop_id}:${sku.id}`, String(sku.purchase_channel).trim())
      })
      return channels
    },
    stockBySku () {
      const stocks = new Map()
      if (!hasPermission(this.$store.state.user, 'product.sku.view')) return stocks
      ;(this.$store.state.skuList || []).forEach(sku => {
        if (sku.stock != null && String(sku.stock).trim() !== '' && Number.isFinite(Number(sku.stock)) && Number(sku.stock) >= 0) {
          stocks.set(`${sku.shop_id}:${sku.id}`, sku.stock)
        }
      })
      return stocks
    },
    isWebClient () {
      return this.$store.getters['app/getIsWebClient']
    },

    planes () {
      const planes = this.$store.state.airList
      return Array.isArray(planes) ? planes : []
    },

    shopList () {
      const list = this.$store.state.shopList
      return Array.isArray(list) ? list : []
    },

    currentShop () {
      const shopId = this.refundItem ? this.refundItem.shop_id : this.shopId
      return this.shopList.find(shop => String(shop.shop_id) === String(shopId)) || {}
    },

    cancelReasonOptions () {
      const preset = Array.isArray(this.currentShop.cancel_remark_presup)
        ? this.currentShop.cancel_remark_presup.filter(Boolean)
        : []
      return preset.concat(['其他原因'])
    },

    showCancelReasonInput () {
      return this.refundForm.cancelReasonSelect === '其他原因'
    },

    needShipmentConfirmBeforeRefund () {
      const order = this.refundItem || {}
      return order.shipment_status === '已发货'
    },

    displayList () {
      const tabType = String(this.type || '').trim()

      const refundProcessingStatus = ['已申请', '已同意', '主动退', '程序退']
      const normalRefundStatus = ['未申请', '拒绝退']

      let displayList = []
      let getSortTime = item => item.order_time

      if (tabType === '退款处理') {
        displayList = this.list.filter(item => {
          return String(item.main_status || '').trim() === '已付款' &&
            refundProcessingStatus.includes(String(item.refund_status || '').trim())
        })
        getSortTime = item => item.refundapply_time || item.refunded_time ||
          item.refundagree_time || item.order_time
      } else {
        displayList = this.list.filter(item => {
          const mainStatus = String(item.main_status || '').trim()
          const shipmentStatus = String(item.shipment_status || '').trim()
          const refundStatus = String(item.refund_status || '').trim()

          return mainStatus === '已付款' &&
            shipmentStatus === tabType &&
            normalRefundStatus.includes(refundStatus)
        })

        const sortTimeGetters = {
          未接单: item => item.paid_time || item.order_time,
          已接单: item => item.received_time || item.paid_time || item.order_time,
          已发货: item => item.shipped_time || item.received_time || item.paid_time || item.order_time
        }
        getSortTime = sortTimeGetters[tabType] || getSortTime
      }

      return displayList.sort((a, b) => {
        const aTime = Number(getSortTime(a)) || Number.MAX_SAFE_INTEGER
        const bTime = Number(getSortTime(b)) || Number.MAX_SAFE_INTEGER
        return aTime - bTime
      })
    }
  },

  methods: {
    orderProductRows (order) {
      const groups = new Map()
      ;(order.product_snapshot || []).forEach((spu, index) => {
        const key = spu.spu_id == null || spu.spu_id === '' ? `snapshot:${index}` : `spu:${spu.spu_id}`
        if (!groups.has(key)) groups.set(key, { name: spu.spu_name, skus: [] })
        groups.get(key).skus.push(...(spu.sku_arr || []))
      })
      return Array.from(groups.values()).flatMap(group =>
        group.skus.map((sku, index) => ({
          ...sku,
          productGroupName: group.name,
          productGroupSpan: index === 0 ? group.skus.length : 0
        }))
      )
    },
    orderProductSpan ({ row, column }) {
      return column.property === 'productGroupName' ? [row.productGroupSpan, 1] : [1, 1]
    },
    customerRemarkText (order) {
      return order.remark == null ? '' : String(order.remark).trim()
    },
    skuPurchaseChannelText (sku, shopId) {
      const snapshotChannel = sku.sku_purchase_channel == null ? '' : String(sku.sku_purchase_channel).trim()
      return snapshotChannel || this.purchaseChannelBySku.get(`${shopId}:${sku.sku_id}`) || ''
    },
    skuStockText (sku, shopId) {
      const stock = this.stockBySku.get(`${shopId}:${sku.sku_id}`)
      return stock == null ? '—' : `${stock}${sku.sku_unit || ''}`
    },
    handleDetailVisibility (orderId, visible) {
      if (!visible && this.activeNames === orderId) this.activeNames = ''
    },
    parseTime,
    isRefundBusy (order) {
      return Boolean(order) && (
        ['已同意', '主动退', '程序退'].includes(order.refund_status) ||
        this.refundIndex === order.id || this.refundSubmittingId === order.id
      )
    },
    questAss (...args) {
      if (!hasPermission(this.$store.state.user, 'terminal.dashboard')) return
      const item = (this.list || []).find(order => String(order.id) === String(args[0]))
      if (!item || this.isRefundBusy(item)) return
      return questAss(...args)
    },
    async confirmRejectRefund (item) {
      if (!hasPermission(this.$store.state.user, 'terminal.dashboard') || item.refund_status !== '已申请' || this.isRefundBusy(item)) return
      try {
        await this.$confirm(t('拒绝退款后，客户将无法再次申请退款。确定要拒绝这笔退款吗？'), t('确认拒绝退款'), {
          confirmButtonText: t('确认拒绝'),
          cancelButtonText: t('取消'),
          type: 'warning'
        })
      } catch (error) {
        return
      }
      const current = (this.list || []).find(order => String(order.id) === String(item.id))
      if (!current || current.refund_status !== '已申请' || this.isRefundBusy(current)) return
      return this.questAss(item.id, 'refund_status', '拒绝退')
    },
    canRefundOrder (order) {
      return Boolean(order) && hasPermission(this.$store.state.user, 'terminal.dashboard') &&
        (order.shipment_status !== '已发货' || hasPermission(this.$store.state.user, 'terminal.dashboard'))
    },

    formatRefundRemark (remark) {
      const text = remark || ''
      const textMap = {
        '日终仍未闭环，自动处理客户退款申请': '客户退款申请未完成处理，系统已自动发起退款',
        '客户退款申请未完成处理，系统已自动发起退款': '客户退款申请未完成处理，系统已自动发起退款',
        '退款申请长时间未处理，系统已自动发起退款': '退款申请长时间未处理，系统已自动发起退款',
        '日终仍未完成配送，自动全额退款': '订单未完成配送，系统已自动发起全额退款',
        '订单未完成配送，系统已自动发起全额退款': '订单未完成配送，系统已自动发起全额退款',
        '订单超时未完成配送，系统已自动发起全额退款': '订单超时未完成配送，系统已自动发起全额退款'
      }
      return textMap[text] || text || '无'
    },

    // 元转分。前端不要直接用 Number 金额相加，避免 19.950000000000003。
    yuanToFen (amount) {
      const value = String(amount || '').trim()
      if (!value) return 0

      const negative = value.charAt(0) === '-'
      const pureValue = negative ? value.slice(1) : value

      const parts = pureValue.split('.')
      const yuan = String(parts[0] || '0').replace(/\D/g, '') || '0'
      const decimal = String(parts[1] || '').replace(/\D/g, '')

      const cent = decimal.padEnd(2, '0').slice(0, 2)
      const third = Number(decimal.charAt(2) || 0)

      let fen = Number(yuan) * 100 + Number(cent || 0)

      if (third >= 5) {
        fen += 1
      }

      return negative ? -fen : fen
    },

    // 分转元字符串，统一保留两位小数。
    fenToYuan (fen) {
      return (Number(fen || 0) / 100).toFixed(2)
    },

    // 订单应付总额，返回元字符串。
    calcOrderPayAmount (item) {
      const totalFen =
        this.yuanToFen(item.total_price) +
        this.yuanToFen(item.transport_price) +
        this.yuanToFen(item.pack_price)

      return this.fenToYuan(totalFen)
    },

    handlerRouterPlane (plane) {
      if (!hasPermission(this.$store.state.user, 'terminal.dashboard')) return
      if (this.compact) this.activeNames = ''
      this.$router.push({ path: '/home/index', query: { plane_id: plane.id } })
      this.$emit('close-drawer')
    },

    async refund () {
      if (!this.canRefundOrder(this.refundItem) || this.isRefundBusy(this.refundItem)) return
      this.$refs.refundFormRef.validate(async (valid) => {
        if (!valid || !this.canRefundOrder(this.refundItem) || this.isRefundBusy(this.refundItem) || this.refundSubmittingId !== null) return

        this.refundSubmittingId = this.refundItem.id
        try {
          if (!await this.ensureShipmentReadyForRefund()) return

          let refundRemark = ''
          if (this.refundType !== 'buyer') {
            if (this.refundForm.cancelReasonSelect === '其他原因') {
              refundRemark = (this.refundForm.cancelReasonInput || '').trim()
            } else {
              refundRemark = this.refundForm.cancelReasonSelect || ''
            }
          }

          const res = await refund(
            this.refundOrder_sn,
            this.refundShop_id,
            this.refundForm.refundPrice,
            this.refundType,
            refundRemark
          )

          if (res.data.status === 1) {
            this.dialogVisible = false
            scheduleRefundReconciliation(this.refundItem.id)
            this.refundIndex = this.refundItem.id
            this.$refs.refundFormRef.resetFields()
          }
        } finally {
          this.refundSubmittingId = null
          await this.$store.dispatch('fetchPaidOrderList')
        }
      })
    },
    async ensureShipmentReadyForRefund () {
      const order = this.refundItem || {}
      if (order.shipment_status !== '已发货') return true

      const planeId = order.by_plane_id
      if (!planeId) {
        this.$message.error(t('订单缺少执行飞机信息，请先人工核对配送状态'))
        return false
      }

      if (!this.refundShipmentResult) {
        this.$message.warning(t('请先确认货物是否已送达'))
        return false
      }

      return await this.finishShipmentBeforeRefund(order, this.refundShipmentResult)
    },

    async finishShipmentBeforeRefund (order, result) {
      if (!hasPermission(this.$store.state.user, 'terminal.dashboard')) return false
      const res = await finishDeliveryTask({
        shop_id: order.shop_id,
        order_id: order.id,
        plane_id: order.by_plane_id,
        result,
        mission_token: order.mission_token
      })
      if (res.data.status === 1) {
        this.refundItem = Object.assign({}, order, {
          shipment_status: result === 'delivered' ? '已送达' : '已接单',
          by_plane_id: result === 'delivered' ? order.by_plane_id : null
        })
        return true
      }
      return false
    },
    setRefundItem (item, refundType) {
      if (!this.canRefundOrder(item) || this.isRefundBusy(item)) return
      this.dialogVisible = true
      this.refundForm.cancelReasonSelect = ''
      this.refundForm.cancelReasonInput = ''
      this.refundShipmentResult = ''

      const orderPayAmount = this.calcOrderPayAmount(item)

      this.refundTotal_price = orderPayAmount
      this.refundApply_price = this.fenToYuan(this.yuanToFen(item.apply_price))
      this.refundForm.refundPrice = refundType === 'buyer'
        ? this.fenToYuan(this.yuanToFen(item.apply_price))
        : orderPayAmount

      this.refundOrder_sn = item.order_sn
      this.refundShop_id = item.shop_id
      this.refundType = refundType
      this.refundItem = item

      this.$nextTick(() => {
        this.$refs.refundFormRef && this.$refs.refundFormRef.clearValidate()
      })
    },

    async orderPrint (index) {
      if (!hasPermission(this.$store.state.user, 'terminal.dashboard')) return
      const item = this.displayList[index] || {}
      const orderId = String(item.id || '')
      if (!orderId || this.printingOrderIds.includes(orderId) ||
        (this.dialogVisible && this.refundItem && this.refundItem.id === item.id) ||
        this.isRefundBusy(item)) return
      this.printingOrderIds.push(orderId)
      try {
        await this.$confirm(t('确认打印订单 #{0} 的小票？', [item.food_sn || '--']), t('打印小票'), {
          confirmButtonText: t('确认打印'),
          cancelButtonText: t('取消'),
          type: 'warning'
        })
      } catch (error) {
        this.finishOrderPrinting(orderId)
        return
      }
      const currentOrder = (this.list || []).find(order => String(order.id) === orderId)
      if (!currentOrder || this.isRefundBusy(currentOrder)) {
        this.finishOrderPrinting(orderId)
        return
      }
      if (!window.BTPrinter || typeof window.BTPrinter.printTitle !== 'function') {
        this.$message.error(t('打印插件未加载'))
        this.finishOrderPrinting(orderId)
        return
      }

      try {
        const isConnected = await isReceiptPrinterConnected()
        if (!isConnected) {
          window.dispatchEvent(new Event('bt-printer-offline'))
          this.$message.error(t('未连接打印机，本次未计入打印次数'))
          this.finishOrderPrinting(orderId)
          return
        }
      } catch (error) {
        this.$message.error(t(error.message || '无法确认打印机连接状态'))
        this.finishOrderPrinting(orderId)
        return
      }

      let currentPrintCount = 0
      try {
        const recordResponse = await recordOrderPrint(item.id, item.shop_id)
        if (!recordResponse || !recordResponse.data || recordResponse.data.status !== 1) {
          this.$message.error(t(recordResponse?.data?.msg || '打印次数登记失败'))
          this.finishOrderPrinting(orderId)
          return
        }
        currentPrintCount = Number(recordResponse.data.print_count) || 1
        this.$set(item, 'print_count', currentPrintCount)
      } catch (error) {
        this.$message.error(t('打印次数登记失败，请检查网络'))
        this.finishOrderPrinting(orderId)
        return
      }

      const telRaw = String(item.tel || '')
      const tel = telRaw.length >= 7
        ? telRaw.substr(0, 3) + '****' + telRaw.substr(7)
        : telRaw

      try {
        let con = ''

        con = '飞行魔方物流平台'
        await this.btPrintAsync(con, '10', '1')

        con = this.printSequenceText(currentPrintCount)
        await this.btPrintAsync(con, '0', '1')

        con = ''
        con += '------------客户信息------------\n'
        con += '昵称：' + (item.receiver || '') + '\n'
        con += '电话：' + tel + '\n'
        con += '------------订单信息------------'
        await this.btPrintAsync(con, '0', '0')

        con = ''
        con += '取餐号：' + (item.food_sn || '')
        await this.btPrintAsync(con, '31', '0')

        con = ''
        con += '单号：' + (item.order_sn || '') + '\n'
        con += '收货站点：' + (item.receive_site_name || '') + '\n'

        const orderTs = item.order_time || item.paid_time
        con += '下单时间：' + (orderTs ? this.parseTime(orderTs) : '-') + '\n'

        if (item.remark) {
          con += '------------客户备注------------\n'
          con += item.remark + '\n'
        }

        con += '--------------商品--------------\n'

        const spuMap = new Map()
        ;(Array.isArray(item.product_snapshot) ? item.product_snapshot : []).forEach(spu => {
          const spuName = (spu.spu_name || '未命名SPU').trim()
          if (!spuMap.has(spuName)) {
            spuMap.set(spuName, { qty: 0, skus: [] })
          }

          const group = spuMap.get(spuName)
          ;(Array.isArray(spu.sku_arr) ? spu.sku_arr : []).forEach(sku => {
            const skuQty = Number(sku.sku_totol || 0)
            group.qty += skuQty
            group.skus.push({
              name: sku.sku_name || '未命名SKU',
              qty: skuQty,
              unit: sku.sku_unit || '',
              number: sku.sku_number || ''
            })
          })
        })

        let groupIndex = 0
        for (const [spuName, group] of spuMap) {
          if (groupIndex++) con += '----------------------------\n'
          if (group.skus.length > 1) con += `${spuName} x${group.qty}\n`
          for (const sku of group.skus) {
            con += this.receiptSkuLine(`${sku.name} x${sku.qty}${sku.unit}`, `编号：${sku.number || '-'}`)
          }
        }
        con += '------------小计------------\n'
        const totalNum = Number(item.total_num || 0)
        const goodsTotal = this.fenToYuan(this.yuanToFen(item.total_price))
        const transport = this.fenToYuan(this.yuanToFen(item.transport_price))
        const pack = this.fenToYuan(this.yuanToFen(item.pack_price))
        const payTotal = this.calcOrderPayAmount(item)

        con += '货品总数：' + totalNum + '\n'
        con += '货品总额：' + goodsTotal + '\n'
        con += '配送费：' + transport + '\n'
        con += '打包费：' + pack + '\n'
        con += '应付总额：' + payTotal + '\n'
        con += '---------加盟无人机送餐---------'
        await this.btPrintAsync(con, '0', '0')

        await this.printQRCodeAsync('https://flicube.com', 1, 49, 64, 50)
        await this.btPrintAsync('请扫上列二维码关注 飞行魔方\n\n', '0', '1')
      } catch (err) {
        console.log('print error', err)
        window.dispatchEvent(new Event('bt-printer-offline'))
        this.$message.error(t('未连接打印机'))
      } finally {
        this.finishOrderPrinting(orderId)
      }
    },

    isOrderPrinting (item) {
      return this.printingOrderIds.includes(String((item && item.id) || ''))
    },

    finishOrderPrinting (orderId) {
      this.printingOrderIds = this.printingOrderIds.filter(id => id !== String(orderId))
    },

    printCount (item) {
      return Math.max(0, Number(item && item.print_count) || 0)
    },

    printSequenceText (count) {
      return Number(count) === 1 ? '首次打印' : `第${Number(count)}次打印`
    },

    receiptSkuLine (label, number) {
      const columns = 30
      const width = value => [...value].reduce((sum, char) => sum + (char.charCodeAt(0) > 127 ? 2 : 1), 0)
      const gap = columns - width(label) - width(number)
      return gap >= 0
        ? `${label}${' '.repeat(gap)}${number}\n`
        : `${label}\n${' '.repeat(Math.max(0, columns - width(number)))}${number}\n`
    },

    btPrintAsync (str, size = '0', align = '0') {
      return new Promise((resolve, reject) => {
        window.BTPrinter.printTitle(
          () => setTimeout(resolve, 120),
          err => reject(err),
          str, size, align
        )
      })
    },

    printQRCodeAsync (data, align, model, size, eclevel) {
      return new Promise((resolve, reject) => {
        window.BTPrinter.printQRCode(
          () => setTimeout(resolve, 160),
          err => reject(err),
          data, align, model, size, eclevel
        )
      })
    }
  },

  watch: {
    list (orders) {
      if (this.refundIndex !== null) {
        const pending = orders.find(order => String(order.id) === String(this.refundIndex))
        if (!pending || ['已同意', '主动退', '程序退'].includes(pending.refund_status)) this.refundIndex = null
      }
      if (!this.dialogVisible || !this.refundItem || this.refundSubmittingId !== null) return
      const current = orders.find(order => String(order.id) === String(this.refundItem.id))
      const allowed = this.refundType === 'buyer' ? ['已申请'] : ['未申请', '拒绝退']
      if (!current || current.main_status !== '已付款' || !allowed.includes(current.refund_status)) {
        this.dialogVisible = false
      }
    },

    showCancelReasonInput (val) {
      if (!val) this.refundForm.cancelReasonInput = ''
    },

    dialogVisible (val) {
      if (!val && this.$refs.refundFormRef) {
        this.$refs.refundFormRef.resetFields()
      }
    }
  }
}
</script>

<style lang="scss" scoped>
@import "@/styles/theme.scss";

.is-compact-orders::v-deep .el-descriptions__table { table-layout: fixed; width: 100%; }
.is-compact-orders::v-deep .el-descriptions-item__content { overflow-wrap: anywhere; }
.is-compact-orders { padding: var(--ui-space-sm); }
.is-compact-orders .order-metrics { grid-template-columns: 1fr; }
.is-compact-orders .order-actions::v-deep .ui-button-group { flex-direction: column; align-items: stretch; }
.is-compact-orders .order-actions::v-deep .ui-button { width: 100%; margin-left: 0; }
.is-compact-orders::v-deep .el-collapse .el-collapse-item { margin-bottom: var(--ui-space-sm); border-bottom: 0; }
.is-compact-orders::v-deep .el-collapse-item:last-child { margin-bottom: 0; }
.is-compact-orders::v-deep .el-collapse .el-collapse-item__header {
  height: auto;
  min-height: var(--ui-control-height);
  padding: var(--ui-space-sm);
  border: 1px solid var(--ui-border-color-subtle);
  border-radius: var(--ui-radius-medium);
  box-sizing: border-box;
  line-height: 1.5;
}
.is-compact-orders::v-deep .el-collapse-item__header.is-active { border-color: var(--ui-color-primary); }
.is-compact-orders .order-summary { display: grid; gap: var(--ui-space-xs); min-width: 0; }
.is-compact-orders .order-summary__heading { color: var(--ui-text-primary); font-size: var(--gs-font-section, 14px); line-height: 22px; font-weight: var(--ui-font-weight-medium); }
.is-compact-orders .order-summary__id { font-variant-numeric: tabular-nums; }
.is-compact-orders .order-summary__site { display: inline-block; max-width: 100%; vertical-align: top; color: var(--ui-color-primary); }
.is-compact-orders .order-summary__separator { color: var(--ui-text-primary); }
@media (hover: hover) and (pointer: fine) {
  .is-compact-orders::v-deep .el-collapse-item__header:not(.is-active):hover { border-color: var(--ui-border-color-strong); }
}
.is-compact-orders::v-deep .el-collapse-item__header .w-50 { float: none !important; width: 100% !important; overflow-wrap: anywhere; text-align: left; padding-right: 0; }
.is-compact-orders::v-deep .el-collapse-item__header .r { color: var(--ui-text-secondary); font-size: var(--ui-font-size-caption); font-weight: 400; }
.is-compact-orders::v-deep .el-collapse-item__wrap { display: none !important; }
.is-compact-orders::v-deep .el-collapse-item__arrow { display: none; }
.is-compact-orders::v-deep .workbench-order-detail-dialog { display: flex; flex-direction: column; max-width: calc(100vw - 32px); max-height: calc(100vh - 60px); margin-top: var(--ui-space-lg) !important; }
.is-compact-orders::v-deep .workbench-order-detail-dialog .el-dialog__header,
.is-compact-orders::v-deep .workbench-order-detail-dialog .el-dialog__footer { flex-shrink: 0; }
.is-compact-orders::v-deep .workbench-order-detail-dialog .el-dialog__body { min-height: 0; overflow-y: auto; box-sizing: border-box; padding: var(--ui-space-lg) var(--ui-space-lg) 0; }
.is-compact-orders::v-deep .workbench-order-detail-dialog .el-dialog__footer .order-actions { margin: 0; padding: 0; border: 0; }
.is-compact-orders::v-deep .workbench-order-detail-dialog .order-detail-card { padding: 0; }
.is-compact-orders::v-deep .workbench-order-detail-dialog .order-detail-section { margin-top: var(--ui-space-lg); }
.is-compact-orders::v-deep .workbench-order-detail-dialog .ui-form-divider { margin: 0 0 var(--ui-space-sm); }
.is-compact-orders::v-deep .workbench-order-detail-dialog .order-metrics { grid-template-columns: repeat(3, minmax(0, 1fr)); margin-top: var(--ui-space-md); }
.is-compact-orders::v-deep .workbench-order-detail-dialog .order-primary-info .el-descriptions__body,
.is-compact-orders::v-deep .workbench-order-detail-dialog .order-delivery-info .el-descriptions__body { overflow: hidden; border: 1px solid var(--ui-border-color); border-radius: var(--ui-radius-medium); }
.is-compact-orders::v-deep .workbench-order-detail-dialog .el-descriptions__table { border-style: hidden; }
.is-compact-orders::v-deep .workbench-order-detail-dialog .order-primary-info .el-descriptions-item__content { color: var(--ui-text-primary); }
.is-compact-orders::v-deep .workbench-order-detail-dialog .order-primary-info .el-descriptions__table { table-layout: auto; }
.is-compact-orders::v-deep .workbench-order-detail-dialog .order-primary-info .el-descriptions-item__cell { white-space: nowrap; }
.is-compact-orders::v-deep .workbench-order-detail-dialog .order-number { display: block; max-width: min(220px, 30vw); overflow: hidden; text-overflow: ellipsis; white-space: nowrap; font-variant-numeric: tabular-nums; }
.is-compact-orders::v-deep .workbench-order-detail-dialog .order-metrics strong { color: var(--ui-text-primary); font-size: var(--ui-font-size-body); }
.is-compact-orders::v-deep .workbench-order-detail-dialog .order-products-scroll { max-height: clamp(200px, calc(100vh - 552px), 360px); overflow-y: auto; overscroll-behavior-y: contain; background: var(--ui-bg-panel); border: 1px solid var(--ui-border-color); border-radius: var(--ui-radius-medium); scrollbar-width: thin; scrollbar-color: var(--ui-border-color) var(--ui-bg-canvas); }
.is-compact-orders::v-deep .workbench-order-detail-dialog .order-products-scroll::-webkit-scrollbar { width: 7px; }
.is-compact-orders::v-deep .workbench-order-detail-dialog .order-products-scroll::-webkit-scrollbar-track { background: var(--ui-bg-canvas); }
.is-compact-orders::v-deep .workbench-order-detail-dialog .order-products-scroll::-webkit-scrollbar-thumb { background: var(--ui-border-color); border-radius: var(--ui-radius-medium); }
.is-compact-orders::v-deep .workbench-order-detail-dialog .order-products .ui-table { border: 0; border-radius: 0; }
.is-compact-orders::v-deep .workbench-order-detail-dialog .order-products th.el-table__cell { height: 40px; }
.is-compact-orders::v-deep .workbench-order-detail-dialog .order-products td.el-table__cell { height: 40px; padding: 9px 0; }
.is-compact-orders::v-deep .workbench-order-detail-dialog .order-actions .ui-button-group { width: 100%; flex-direction: row; flex-wrap: wrap; justify-content: flex-end; gap: var(--ui-space-sm); }
.is-compact-orders::v-deep .workbench-order-detail-dialog .order-actions .ui-button { width: auto; flex: none; }

@media (max-width: 600px) {
  .is-compact-orders::v-deep .workbench-order-detail-dialog .el-descriptions__table,
  .is-compact-orders::v-deep .workbench-order-detail-dialog .el-descriptions__table tbody { display: block; }
  .is-compact-orders::v-deep .workbench-order-detail-dialog .el-descriptions__table tr { display: grid; grid-template-columns: minmax(72px, 1fr) minmax(0, 2fr); }
  .is-compact-orders::v-deep .workbench-order-detail-dialog .order-primary-info .el-descriptions-item__cell,
  .is-compact-orders::v-deep .workbench-order-detail-dialog .el-descriptions-item__cell { min-width: 0; white-space: normal; border: 0; border-bottom: 1px solid var(--ui-border-color); }
  .is-compact-orders::v-deep .workbench-order-detail-dialog .el-descriptions-item__cell:nth-last-child(-n+2) { border-bottom: 0; }
  .is-compact-orders::v-deep .workbench-order-detail-dialog .el-descriptions-item__label { border-right: 1px solid var(--ui-border-color); }
  .is-compact-orders::v-deep .workbench-order-detail-dialog .order-number { max-width: 100%; }
  .is-compact-orders::v-deep .workbench-order-detail-dialog .order-metrics { grid-template-columns: 1fr; }
}

.orterTit {
  display: flex;
  justify-content: space-between;
}

.refund-fail-note {
  color: var(--el-color-warning);
  margin-left: var(--ui-space-xs);
}

.print-count {
  margin-left: var(--ui-space-xs);
  font-size: 12px;
  font-weight: 400;
  opacity: .78;
}

.order-detail-card {
  padding: 0 var(--ui-space-md) var(--ui-space-lg);
  color: var(--ui-text-regular);
}

.order-detail-section {
  margin-top: var(--ui-space-lg);
}

.order-detail-section > h4::before {
  width: 3px;
  height: 12px;
  display: inline-block;
  margin-right: var(--ui-space-xs);
  border-radius: 2px;
  background: var(--ui-color-primary);
  content: '';
  vertical-align: -1px;
}

.order-primary-info::v-deep .el-descriptions-item__content {
  color: var(--ui-color-primary);
  font-size: var(--ui-font-size-body);
  font-weight: var(--ui-font-weight-medium);
}

.order-delivery-info::v-deep .el-descriptions-item__content {
  color: var(--ui-text-primary);
}

.order-metrics {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: var(--ui-space-sm);
  margin-top: var(--ui-space-sm);
}

.order-metrics > div {
  min-width: 0;
  display: flex;
  align-items: baseline;
  justify-content: space-between;
  gap: var(--ui-space-sm);
  padding: var(--ui-space-sm) var(--ui-space-md);
  border: 1px solid var(--ui-border-color-subtle);
  border-radius: var(--ui-radius-small);
  background: rgba(var(--ui-bg-elevated-rgb), .55);
}

.refund-current-status {
  margin-bottom: var(--ui-space-sm);
  color: var(--ui-text-secondary);
}

.refund-edit-icon {
  margin-left: var(--ui-space-xs);
}

.order-metrics span {
  color: var(--ui-text-secondary);
  font-size: var(--ui-font-size-caption);
}

.order-metrics strong {
  color: var(--ui-color-warning);
  font-size: var(--ui-font-size-section-title);
  font-weight: var(--ui-font-weight-bold);
}

.order-metrics small {
  margin-left: 2px;
  color: var(--ui-text-secondary);
  font-size: var(--ui-font-size-caption);
  font-weight: 400;
}

.order-product-name {
  color: var(--ui-text-primary);
  font-weight: var(--ui-font-weight-medium);
  white-space: normal;
  overflow-wrap: anywhere;
}

.order-product-group {
  color: var(--ui-text-primary);
  font-weight: var(--ui-font-weight-medium);
  white-space: normal;
  overflow-wrap: anywhere;
}

.order-products::v-deep .order-product-group-cell {
  border-right: 1px solid var(--ui-border-color);
}

// Rowspan removes the first cell on subsequent rows; keep SKU indentation stable.
.order-products::v-deep .ui-table.el-table .el-table__cell.order-product-name-cell .cell {
  padding-left: 10px !important;
  padding-right: 10px;
}

.order-products::v-deep .ui-table.el-table .el-table__body tr > td.order-product-group-cell {
  background: var(--ui-bg-panel-elevated) !important;
}

.order-product-channel {
  margin-top: var(--ui-space-xs);
  color: var(--ui-text-secondary);
  font-size: var(--ui-font-size-caption);
  font-weight: 400;
  white-space: normal;
  overflow-wrap: anywhere;
}

.order-products::v-deep td.el-table__cell {
  vertical-align: middle;
  font-variant-numeric: tabular-nums;
}

.order-products::v-deep .order-product-quantity {
  color: var(--ui-text-primary);
  font-weight: var(--ui-font-weight-bold);
}

.order-note > p {
  min-height: 36px;
  margin: 0;
  padding: var(--ui-space-sm) var(--ui-space-md);
  color: var(--ui-text-regular);
  border-left: 2px solid var(--ui-color-warning);
  background: rgba(var(--ui-color-warning-rgb), .06);
  box-sizing: border-box;
  line-height: 20px;
}

.order-actions {
  padding-top: var(--ui-space-md);
  border-top: 1px solid var(--ui-border-color-subtle);
}

@media (max-width: 720px) {
  .order-metrics { grid-template-columns: 1fr; }
}
</style>
